export default "__VITE_ASSET__Dus4G6jl__"